import chapterColors from '../ConfigFiles/chapter_colors.jsx';

export const pick_color = (tag) => {
    switch (tag.slice(0, 1)) {
      case '1':
        return chapterColors.chapter01Color
      case '2':
        return chapterColors.chapter02Color
      case '3':
        return chapterColors.chapter03Color
      case '4':
        return chapterColors.chapter04Color
      case '5':
        return chapterColors.chapter05Color
      case '6':
        return chapterColors.chapter06Color
      case '7':
        return chapterColors.chapter07Color
      case '8':
        return chapterColors.chapter08Color
      case '9':
        return chapterColors.chapter09Color
      case 'A':
        return chapterColors.chapter10Color
      case 'B':
        return chapterColors.chapter11Color
      case 'C':
        return chapterColors.chapter12Color
      case 'D':
        return chapterColors.chapter13Color
      case 'E':
        return chapterColors.chapter14Color
      case 'F':
        return chapterColors.chapter15Color
      case 'G':
        return chapterColors.chapter16Color
      case 'H':
        return chapterColors.chapter17Color
      case 'I':
        return chapterColors.chapter18Color
      case 'J':
        return chapterColors.chapter19Color
      case 'K':
        return chapterColors.chapter20Color
      case 'L':  
        return chapterColors.chapter21Color
      case 'M':
        return chapterColors.chapter22Color
      case 'N':
        return chapterColors.chapter23Color
      case 'O':
        return chapterColors.chapter24Color
      case 'P':
        return chapterColors.chapter25Color
      case 'Q':
        return chapterColors.chapter26Color
      default:
        return chapterColors.chapter00Color
    }
  }